import React, { useEffect } from 'react';
import { ToastNotification } from '@carbon/react';
// import { X } from "@carbon/icons-react"; // Close icon

interface NotificationProps {
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
  isVisible: boolean;
  onClose: () => void;
  subTitle?: string;
}

const Notification: React.FC<NotificationProps> = ({
  message,
  type,
  isVisible,
  onClose,
  subTitle,
}) => {
  useEffect(() => {
    if (isVisible) {
      // Auto hide the notification after 3 seconds
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer); // Clean up the timeout on unmount or if the message changes
    }
  }, [isVisible, onClose]);

  const getColorByType = (type: string) => {
    switch (type) {
      case 'success':
        return '#dafbe4'; // light green
      case 'error':
        return '#fdecea'; // light red
      case 'warning':
        return '#fff4ce'; // light yellow
      case 'info':
        return '#e5f6ff'; // light blue
      default:
        return '#ffffff';
    }
  };

  if (!isVisible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '1rem',
        right: '1rem',
        zIndex: 9999,
        minWidth: '300px',
        backgroundColor: getColorByType(type), // Optional override
        borderRadius: '10px',
        width: 'auto',
      }}
    >
      <ToastNotification
        kind={type}
        title={message}
        subtitle={subTitle}
        onClose={onClose}
        lowContrast={true}
        // timeout={10000000000000000000000000000000} // Prevent auto-close, we handle it manually
        //   iconDescription="Close"
        //   caption={<X size={16} />} // Close button
        hideCloseButton={false}
        role="alert"
        aria-live="assertive"
      />
    </div>
  );
};

export default Notification;
